import axios from "axios";
import { apiPath, apiPath1 } from "../../constants/config";
let token = localStorage.getItem("accessToken");
let config = {
  headers: {
    Authorization: "Bearer " + token
  }
};
const state = {
  isLoadTags: false,
  isLoadRestau10: false,
  errorRestau11: "",
  tags: [],
  tagsSearchResult: null,
  conversationsRestau: null,
};

const getters = {
  isLoadTags: state => state.isLoadTags,
  isLoadRestau10: state => state.isLoadRestau10,
  errorRestau11: state => state.errorRestau11,
  tags: state => state.tags,
};

const mutations = {
  getTagsSuccess(state, payload) {
    state.isLoadTags = true;
    state.tags = payload.tags;
  },
  addTagSuccess(state, payload) {
    // console.log({payload});
    // console.log("FROMMUATETTAGSUCCES");
    state.isLoadTags = true;
    let tags = state.tags;
    tags.push(payload.data);
    state.tags = tags;
  },
  editTagSuccess(state, payload) {
    console.log("FROM MUTATE");
    console.log(payload);
    state.isLoadTags = true;
    let tags = state.tags;

    let newTags = [];
    tags.map((tag, index) => {
      if (tag._id == payload.data._id) {
        newTags.push({ ...payload.data });
      } else {
        newTags.push({ ...tag });
      }
    });
    state.tags = [...newTags];
  },
  deleteTagSuccess(state, payload) {
    state.isLoadTags = true;
    let tags = state.tags;

    let newTags = [];
    tags.map((tag, index) => {
      if (tag._id != payload.data._id) {
        newTags.push({ ...tag });
      }
    });
    state.tags = [...newTags];
  },
  addClientTAGSuccess(state, payload) {
    state.isLoadTags = true;

  },
  getTagsError(state, error) {
    state.isLoadTags = false;
    state.errorRestau11 = error;
  },
  addTagError(state, error) {
    state.isLoadTags = false;
    state.errorRestau11 = error;
  }
};

const actions = {
  getTags({ commit }, payload) {
    // token = localStorage.getItem("accessToken")

    axios
      .get(`${apiPath}/tags?restaurant=${payload}`)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("getTagsSuccess", {
            tags: res.data
          });
        } else {
          commit("getTagsError", "error:getTags");
        }
      });
  },
  addTag({ commit }, payload) {
    return axios
      .post(`${apiPath}/tags`, payload, config)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("addTagSuccess", res);
        } else {
          commit("addTagError", "error:addTag");
        }
        return res;
      });
  },
  editTag({ commit }, payload) {
    console.log("FROM EDIT TAG AXIOS");
    console.log(payload);
    return axios
      .post(`${apiPath}/tags/${payload.id}`, payload.formdata, config)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("editTagSuccess", res);
        } else {
          commit("addTagError", "error:addTag");
        }
        return res;
      });
  },
  // SyncRestau({ commit }, payload,config) {
  //     axios
  //     .post(`${apiPath1}/sync/${payload._id}/get/menu/definition`)
  //     .then(r => r.data)
  //     .then(res => {
  //     });
  //     axios
  //     .post(`${apiPath1}/sync/${payload._id}/get/menu/price`)
  //     .then(r => r.data)
  //     .then(res => {
  //     });

  //     axios
  //     .post(`${apiPath1}/sync/${payload._id}/get/menu/master`)
  //     .then(r => r.data)
  //     .then(res => {
  //     });

  //     axios
  //     .post(`${apiPath1}/sync/${payload._id}/get/menu/class`)
  //     .then(r => r.data)
  //     .then(res => {
  //     });
  //     axios
  //     .post(`${apiPath1}/sync/${payload._id}/get/family/group`)
  //     .then(r => r.data)
  //     .then(res => {
  //     });
  // },

  deleteTag({ commit }, payload) {
    return axios
      .delete(`${apiPath}/tags/${payload._id}`, config)
      .then(r => r.data)
      .then(res => {
        // if (res.ok) {
        //   commit("deletePosSuccess", payload);
        // } else {
        //   commit("addPosError", "error:addPos");
        // }
        return payload;
      });
  },
  createClient({ commit }, payload) {
    return axios
      .post(`${apiPath}/create/client`, payload)
      .then(r => r.data)
      .then(res => {
        if (res.ok) {
          commit("addClientTAGSuccess", res);
        } else {
        }
        return res;
      });
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
